<template lang="html">
  <div>
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">Site Setup</h6>
          <div class="element-box">
            <div class="element-info">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <div class="os-icon os-icon-tasks-checked">
                      </div>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">Site Setup</h5>
                      <div class="element-inner-desc">Here you can change the site settings</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-card v-if="!this.mobile" no-body>
              <b-tabs v-model="tabIndex" pills card vertical nav-wrapper-class="col-md-3 col-sm-3 col-lg-2" content-class="col-md-9 col-sm-9 col-lg-10">
                <b-tab title="General Settings" class="pt-5 pb-5">
                  <SiteSetupGeneralSettings/>
                </b-tab>
                <b-tab title="Login Page" class="pt-5 pb-5">
                  <SiteSetupLoginPage/>
                </b-tab>
                <b-tab title="Appearance" class="pt-5 pb-5">
                  <SiteSetupAppearance/>
                </b-tab>
                <b-tab title="Notification Templates" class="pt-5 pb-5">
                  <SiteSetupNotificationTemplates/>
                </b-tab>
                <b-tab title="Password Templates" class="pt-5 pb-5">
                  <SiteSetupPasswordTemplates/>
                </b-tab>
                <b-tab title="Advanced" class="pt-5 pb-5">
                  <SiteSetupAdvanced/>
                </b-tab>
                <b-tab title="Watermarks" class="pt-5 pb-5">
                  <SiteSetupWatermarks/>
                </b-tab>
                <b-tab title="User levels" class="pt-5 pb-5">
                  <SiteSetupUserLevels/>
                </b-tab>
                <b-tab title="Registration Form" class="pt-5 pb-5">
                  <SiteSetupRegistrationForm/>
                </b-tab>
                <b-tab title="FAQ Upload" class="pt-5 pb-5">
                  <SiteSetupFAQUpload/>
                </b-tab>
                <b-tab title="Video Tutorials" class="pt-5 pb-5">
                  <SiteSetupVideoTutorials/>
                </b-tab>
                <b-tab title="Client Configuration" class="pt-5 pb-5">
                  <SiteSetupClientConfiguration/>
                </b-tab>
                <b-tab title="Payment Configuration" class="pt-5 pb-5">
                  <SiteSetupPaymentConfiguration/>
                </b-tab>
                <b-tab title="Widget Configuration" class="pt-5 pb-5">
                  <SiteSetupWidgetConfiguration/>
                </b-tab>
              </b-tabs>
            </b-card>
            <div v-else role="tablist">
              <b-card class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-1 variant="primary">General Settings</b-button>
                </b-card-header>
                <b-collapse id="accordion-1" accordion="site-setup" role="tabpanel">
                  <b-card-body>
                    <SiteSetupGeneralSettings/>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-2 variant="primary">Login Page</b-button>
                </b-card-header>
                <b-collapse id="accordion-2" accordion="site-setup" role="tabpanel">
                    <b-card-body>
                      <SiteSetupLoginPage/>
                    </b-card-body>
                </b-collapse>
              </b-card>
              <b-card class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-3 variant="primary">Appearance</b-button>
                </b-card-header>
                <b-collapse id="accordion-3" accordion="site-setup" role="tabpanel">
                  <b-card-body>
                    <SiteSetupAppearance/>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-4 variant="primary">Notification Templates</b-button>
                </b-card-header>
                <b-collapse id="accordion-4" accordion="site-setup" role="tabpanel">
                  <b-card-body>
                    <SiteSetupNotificationTemplates/>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-5 variant="primary">Password Templates</b-button>
                </b-card-header>
                <b-collapse id="accordion-5" accordion="site-setup" role="tabpanel">
                  <b-card-body>
                    <SiteSetupPasswordTemplates/>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-6 variant="primary">Advanced</b-button>
                </b-card-header>
                <b-collapse id="accordion-6" accordion="site-setup" role="tabpanel">
                  <b-card-body>
                    <SiteSetupAdvanced/>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-7 variant="primary">Watermarks</b-button>
                </b-card-header>
                <b-collapse id="accordion-7" accordion="site-setup" role="tabpanel">
                  <b-card-body>
                    <SiteSetupWatermarks/>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-8 variant="primary">User levels</b-button>
                </b-card-header>
                <b-collapse id="accordion-8" accordion="site-setup" role="tabpanel">
                  <b-card-body>
                    <SiteSetupUserLevels/>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-9 variant="primary">Registration Form</b-button>
                </b-card-header>
                <b-collapse id="accordion-9" accordion="site-setup" role="tabpanel">
                  <b-card-body>
                    <SiteSetupRegistrationForm/>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-10 variant="primary">FAQ Upload</b-button>
                </b-card-header>
                <b-collapse id="accordion-10" accordion="site-setup" role="tabpanel">
                  <b-card-body>
                    <SiteSetupFAQUpload/>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-11 variant="primary">Client Configuration</b-button>
                </b-card-header>
                <b-collapse id="accordion-11" accordion="site-setup" role="tabpanel">
                  <b-card-body>
                    <SiteSetupClientConfiguration/>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-12 variant="primary">Payment Configuration</b-button>
                </b-card-header>
                <b-collapse id="accordion-12" accordion="site-setup" role="tabpanel">
                  <b-card-body>
                    <SiteSetupPaymentConfiguration/>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-13 variant="primary">Widget Configuration</b-button>
                </b-card-header>
                <b-collapse id="accordion-13" accordion="site-setup" role="tabpanel">
                  <b-card-body>
                    <SiteSetupWidgetConfiguration/>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Navbar from '@/components/Navbar'
import SiteSetupGeneralSettings from '@/components/Site_setup/SiteSetupGeneralSettings.vue'
import SiteSetupLoginPage from '@/components/Site_setup/SiteSetupLoginPage.vue'
import SiteSetupAppearance from '@/components/Site_setup/SiteSetupAppearance.vue'
import SiteSetupNotificationTemplates from '@/components/Site_setup/SiteSetupNotificationTemplates.vue'
import SiteSetupPasswordTemplates from '@/components/Site_setup/SiteSetupPasswordTemplates.vue'
import SiteSetupAdvanced from '@/components/Site_setup/SiteSetupAdvanced.vue'
import SiteSetupWatermarks from '@/components/Site_setup/SiteSetupWatermarks.vue'
import SiteSetupUserLevels from '@/components/Site_setup/SiteSetupUserLevels.vue'
import SiteSetupRegistrationForm from '@/components/Site_setup/SiteSetupRegistrationForm.vue'
import SiteSetupFAQUpload from '@/components/Site_setup/SiteSetupFAQUpload.vue'
import SiteSetupClientConfiguration from '@/components/Site_setup/SiteSetupClientConfiguration.vue'
import SiteSetupPaymentConfiguration from '@/components/Site_setup/SiteSetupPaymentConfiguration.vue'
import SiteSetupWidgetConfiguration from  '@/components/Site_setup/SiteSetupWidgetConfiguration.vue'
import SiteSetupVideoTutorials from "./HelpCentre/SiteSetupVideoTutorials";

export default {
  name: 'sitesetup',
  components:{
    SiteSetupVideoTutorials,
    SiteSetupGeneralSettings,
    SiteSetupLoginPage,
    SiteSetupAppearance,
    SiteSetupNotificationTemplates,
    SiteSetupPasswordTemplates,
    SiteSetupAdvanced,
    SiteSetupWatermarks,
    SiteSetupUserLevels,
    SiteSetupRegistrationForm,
    SiteSetupFAQUpload,
    SiteSetupClientConfiguration,
    SiteSetupPaymentConfiguration,
    SiteSetupWidgetConfiguration
  },
  data() {
    return {
      tabIndex: 0,
      mobile: window.innerWidth <= 700
    }
  },
  created() {
    window.addEventListener('resize', () => {
          this.mobile = window.innerWidth <= 700
    })
  },
  watch: {
    tabIndex: function(){
        this.$store.commit('setValidationErrors', [])
    }
  }
}
</script>

<style lang="css" scoped>

</style>
